import { Typography, Grid2 as Grid } from "@mui/material";

const PatentsAndIp = () => {

    return (
        <>
            <Grid container direction={"column"} spacing={2}>
                <Grid size={8}>
                    <Typography
                        fontWeight={"bold"}
                        fontFamily={"Inter"}
                        fontSize={"16px"}
                        color={"#303030"}
                    >
                        Patents & Ip
                    </Typography>
                </Grid>

                <Grid>
                    <Typography
                        fontWeight={"light"}
                        fontFamily={"Inter"}
                        fontSize={"16px"}
                        color={"#585B5B"}
                        style={{ textDecoration: "underline" }}
                    >
                        List of Competitor Specs
                    </Typography>

                    <ul>
                        <li
                            style={{ color: "#F0C577" }}>
                            <Typography
                                fontWeight={"light"}
                                fontFamily={"Inter"}
                                fontSize={"16px"}
                                color={"#F0C577"}
                            >
                                EU1234567
                            </Typography>
                        </li>

                        <li
                            style={{ color: "#F0C577" }}>
                            <Typography
                                fontWeight={"light"}
                                fontFamily={"Inter"}
                                fontSize={"16px"}
                                color={"#F0C577"}
                            >
                                US2345678
                            </Typography>
                        </li>
                    </ul>
                </Grid>

                <Grid>
                    <Typography
                        fontWeight={"light"}
                        fontFamily={"Inter"}
                        fontSize={"16px"}
                        color={"#585B5B"}
                        style={{ textDecoration: "underline" }}
                    >
                        List of Own Patents
                    </Typography>

                    <ul>
                        <li
                            style={{ color: "#585B5B" }}>
                            <Typography
                                fontWeight={"bold"}
                                fontFamily={"Inter"}
                                fontSize={"16px"}
                                color={"#585B5B"}
                            >
                                no relevant patents defined
                            </Typography>
                        </li>
                    </ul>
                </Grid>
            </Grid>
        </>
    )
}
export default PatentsAndIp;